import { map, pick, pipe } from 'ramda'
import { renameKeys } from '@/utils'

const formatTemplates = map(template =>
  template.data_type === 'options'
    ? {
        ...template,
        metadata: {
          allowed: false,
          options: map(() => ({ selected: false }), template.metadata?.options || {})
        }
      }
    : template
)

const formatAddendum = pipe(
  map(
    pipe(
      pick([
        'id',
        'addendum_type',
        'title',
        'data_type',
        'content',
        'metadata',
        'last_modification_at'
      ]),
      renameKeys({
        id: 'listing_contract_addendum_template_id'
      })
    )
  ),
  formatTemplates
)

export default formatAddendum
